import {getStartOfWeek} from '@igp/shared/utils';

export const PlayerEcologyWeeklyQueryFieldsTypeName = 'PlayerEcologyWeeklyQueryFields';
export const PlayerEcologyWeeklyReportTypeName = 'PlayerEcologyWeeklyReport';
export const PlayerEcologyWeeklyViewModelTypeName = 'PlayerEcologyWeeklyViewModel';
export const PlayerEcologyWeeklyViewModelKeysTypeName = 'PlayerEcologyWeeklyViewModelKeys';
export const PlayerEcologyWeeklySortKeysTypeName = 'PlayerEcologyWeeklySortKeys';
export const PlayerEcologyWeeklyColumnsTypeName = 'PlayerEcologyColumnsKeys';

export const PlayerEcologyWeeklyServiceTypes = {
    service: Symbol('PlayerEcologyWeeklyService'),
    downloadServerStrategy: Symbol('PlayerEcologyWeeklyDownloadServerStrategy'),
} as const;

const availableWeekCount = 14; // ~ 3 months
export const firstAvailableDate = getStartOfWeek(availableWeekCount);
